import React from 'react'
const VELKI_APP_NAME="JOSH365";
// const VELKI_API_URL="http://localhost/agent";
const VELKI_API_URL="https://khelmu.live";
const VELKI_API_KEY = "123";

const VELKI_HOME_URL="https://khelmu.live";
export default VELKI_APP_NAME;
export {VELKI_API_URL,VELKI_API_KEY,VELKI_HOME_URL};